// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';

const Wrapper = styled.div`
    font-size: 1.2em;
    font-weight: 400;
    padding: 0.2em
`;
const I = styled(Icon)`
    margin-right: 0.5em;
`;

const Heading = ({ children, ...props }) => {
    return (
        <Wrapper {...props}>
            {props.icon ? <I icon={props.icon} /> : null}
            {children}
        </Wrapper>
    );
}

export default Heading;